import type { FaireProductEntity } from "../../entity_types/product";

export const p_agq5tezhxc: FaireProductEntity = {
  token: "p_agq5tezhxc",
  type: "product",
  name: "Meet Me at the Bookstore | Bookish Candle | Soy Wax",
  brandToken: "b_9k3bwv3ddx",
  brandName: "A Scent Story Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/f293f20ce6ea857dcbcb0052453b1e514d6665138d3ad0330b58d90905cb36de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7fe8cc7916fff01b06d9d56988f5c69e843bd2bd508f8a0f144651d2914ed50e.jpeg",
    "https://cdn.faire.com/fastly/f0ae0ec0a50caa25dea9ea93046adb6f2ec85831aeb0398fdf1d70607bf2f15c.jpeg",
    "https://cdn.faire.com/fastly/02ac0db4185033df64db3c4fc2b0b3afabe6bef493ffc5f010185cbd06163c62.jpeg",
    "https://cdn.faire.com/fastly/463d3f0ad3fbcdd22b0369c875af8424f5032cf7004c5dea23c00e318f89b342.webp",
    "https://cdn.faire.com/fastly/57e0893d89d0a52bdd2e175beb9f8c7583152844b22710e19fb3a2cac51f3f27.png",
    "https://cdn.faire.com/fastly/2408c990f12a76e54efdc0a04b690b6851744b2f8f3b3090eaa8cdc53eaeb196.jpeg",
    "https://cdn.faire.com/fastly/dd2c1881d7cfeece68c852b2de1453d99bcb746a0090cd1cb54b962b127642eb.png",
  ],
  priceDollars: 6,
  description:
    "𝐁𝐨𝐨𝐤𝐬𝐭𝐨𝐫𝐞 𝐃𝐚𝐭𝐞:\n\nSpend the day with your favorite person, a coffee shop, comfy couches and thousands of books.\n\n𝐒𝐜𝐞𝐧𝐭 𝐒𝐭𝐨𝐫𝐲:\nRaspberry. Lemon. Pink Lotus\n\n𝐂𝐚𝐧𝐝𝐥𝐞 𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• 40 - 80+ hours burn time\n• 4 or 8 oz\n• Sulfate, Paraben + Phthalate free\n• 100% Soy wax\n• Cotton wick\n• Non Toxic",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:56.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
